import React from 'react';
import { 
  Dialog, 
  DialogTitle, 
  DialogContent, 
  Typography, 
  Container, 
  IconButton, 
  Box 
} from '@mui/material';
import { Close } from '@mui/icons-material';

const TermsOfService = ({ open, onClose }) => {
    return (
      <Dialog 
        open={open} 
        onClose={onClose} 
        maxWidth="md" 
        fullWidth
        scroll="paper"
      >
        <DialogTitle>
          <Box display="flex" justifyContent="space-between" alignItems="center">
            <Typography variant="h4" color="#0d9488">
              Terms of Service
            </Typography>
            <IconButton onClick={onClose} aria-label="close">
              <Close />
            </IconButton>
          </Box>
        </DialogTitle>
        
        <DialogContent dividers>
          <Container>
            <Typography variant="h6" gutterBottom>
              1. Acceptance of Terms
            </Typography>
            <Typography paragraph>
              By accessing or using Searcheble.com and its services, you agree to be bound by these Terms of Service. 
              If you do not agree to these terms, please do not use our service.
            </Typography>
  
            <Typography variant="h6" gutterBottom sx={{ mt: 3 }}>
              2. Description of Service
            </Typography>
            <Typography paragraph>
              Searcheble provides an AI-powered search platform for businesses to integrate advanced search functionality 
              into their applications and websites. The service includes API access, dashboard tools, and analytics 
              as described on our website and documentation.
            </Typography>
  
            <Typography variant="h6" gutterBottom sx={{ mt: 3 }}>
              3. Account Registration and Security
            </Typography>
            <Typography paragraph>
              To use Searcheble, you must register for an account. You agree to provide accurate information 
              and keep your account details secure. You are responsible for all activities that occur under your account.
            </Typography>
  
            <Typography variant="h6" gutterBottom sx={{ mt: 3 }}>
              4. Service Pricing and Payment
            </Typography>
            <Typography paragraph>
              Pricing for Searcheble is provided on our website. You agree to pay all applicable fees for the services
              you select. We reserve the right to modify pricing with 30 days' notice to existing subscribers.
            </Typography>
            <Typography component="ul" gutterBottom>
              <li>Subscription fees are billed in advance on a monthly or annual basis</li>
              <li>Usage-based fees are billed in arrears based on your actual usage</li>
              <li>All fees are non-refundable except as expressly provided in these Terms</li>
            </Typography>
  
            <Typography variant="h6" gutterBottom sx={{ mt: 3 }}>
              5. User Conduct and Content
            </Typography>
            <Typography paragraph>
              You agree not to use Searcheble to:
            </Typography>
            <Typography component="ul" gutterBottom>
              <li>Violate any applicable laws or regulations</li>
              <li>Infringe upon the rights of others</li>
              <li>Distribute malware or harmful content</li>
              <li>Attempt to gain unauthorized access to Searcheble or its systems</li>
              <li>Use the service in a way that could damage or overburden our infrastructure</li>
            </Typography>
  
            <Typography variant="h6" gutterBottom sx={{ mt: 3 }}>
              6. Intellectual Property Rights
            </Typography>
            <Typography paragraph>
              Searcheble and its original content, features, and functionality are owned by Searcheble.com 
              and are protected by international copyright, trademark, and other intellectual property laws.
            </Typography>
  
            <Typography variant="h6" gutterBottom sx={{ mt: 3 }}>
              7. Termination
            </Typography>
            <Typography paragraph>
              We may terminate or suspend your account and access to Searcheble immediately, without prior notice, 
              for conduct that we believe violates these Terms or is harmful to other users, us, or third parties.
            </Typography>
  
            <Typography variant="h6" gutterBottom sx={{ mt: 3 }}>
              8. Limitation of Liability
            </Typography>
            <Typography paragraph>
              To the maximum extent permitted by law, Searcheble.com shall not be liable for any indirect, 
              incidental, special, consequential, or punitive damages resulting from your use of or inability 
              to use the service.
            </Typography>
  
            <Typography variant="h6" gutterBottom sx={{ mt: 3 }}>
              9. Changes to Terms
            </Typography>
            <Typography paragraph>
              We reserve the right to modify these Terms at any time. We will provide notice of significant changes 
              through the service or by sending you an email.
            </Typography>
  
            <Typography paragraph sx={{ mt: 3, fontStyle: 'italic' }}>
              Last Updated: March 2024
            </Typography>
          </Container>
        </DialogContent>
      </Dialog>
    );
  };
  
  export default TermsOfService;